import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ScrollText, Loader2 } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);
  if (!logs) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-indigo-500" /></div>;

  return (
    <div className="space-y-6">
      <div><h1 className="font-heading text-3xl font-extrabold text-slate-900">Audit Log</h1><p className="text-slate-500">Complete activity trail — {logs.length} records</p></div>
      <div className="bg-white rounded-xl border border-slate-200 table-scroll">
        {logs.length === 0 ? <div className="py-16 text-center text-slate-400"><ScrollText size={40} className="mx-auto mb-2 opacity-40" />No activity yet.</div> : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="text-left px-4 py-3">Date/Time</th><th className="text-left px-4 py-3">User</th><th className="text-left px-4 py-3">Action</th><th className="text-left px-4 py-3">Module</th><th className="text-left px-4 py-3">Details</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {logs.map((l) => (
                <tr key={l.id} className="hover:bg-slate-50" data-testid={`audit-row-${l.id}`}>
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{l.timestamp?.slice(0, 19).replace("T", " ")}</td>
                  <td className="px-4 py-3 font-medium text-slate-800">{l.user}</td>
                  <td className="px-4 py-3">{l.action}</td>
                  <td className="px-4 py-3"><span className="px-2 py-0.5 rounded-full bg-slate-100 text-xs">{l.module}</span></td>
                  <td className="px-4 py-3 text-slate-400 text-xs max-w-xs truncate">{l.new_value ? JSON.stringify(l.new_value) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
